import styles from './NavigationOverlayHeader.module.scss';

import { Paper } from '@mui/material';
import clsx from 'clsx';
import React from 'react';

import {
  Breadcrumbs,
  IBreadrumbsClasses,
} from '@work4all/components/lib/navigation/breadcrumbs/Breadcrumbs';
import { useHistoryStack } from '@work4all/components/lib/navigation/history-stack/hooks/useHistoryStack';

interface INavigationOverlayHeader {
  children?: React.ReactNode;
  classes?: {
    breadcrumbs?: IBreadrumbsClasses;
  };
  breadcrumbsChildren?: React.ReactNode;
  tabs?: React.ReactNode;
  title?: string;
  subTitle?: string;
  breadcrumbTitle?: string;
  horizontalPadding?: 'xxs' | 'xs' | 's';
  hideBreadcrumbs?: boolean;
  forceStackItems?: boolean;
}

export const NavigationOverlayHeader: React.FC<INavigationOverlayHeader> = (
  props
) => {
  const {
    title,
    subTitle,
    breadcrumbTitle,
    classes,
    breadcrumbsChildren,
    tabs,
    children,
    hideBreadcrumbs,
    forceStackItems = false,
  } = props;

  const {
    viewStackItem: current,
    viewIndex,
    stack,
    close,
    goBack,
  } = useHistoryStack();

  let verticalPadding = 's';
  if (viewIndex > 0) {
    /** breadcrumbs will be shown. with breadcrumbs padding should be "xs" */
    verticalPadding = 'xs';
  }

  return (
    <Paper className={styles.root}>
      <div className={styles.breadcrumbsAndChildrenWrapper}>
        <div className={styles.breadcrumbsWrapper}>
          <Breadcrumbs
            classes={{
              ...classes?.breadcrumbs,
              root: clsx(styles.breadcrumbs, classes?.breadcrumbs?.root, {
                [styles[`verticalPadding--${verticalPadding}`]]:
                  verticalPadding,
              }),
              heading: clsx(
                styles.breadcrumbsHeading,
                classes?.breadcrumbs?.heading
              ),
            }}
            withMinHeight={false}
            current={current}
            currentIndex={viewIndex}
            goBack={goBack}
            stack={stack}
            close={close}
            hideBreadcrumbs={hideBreadcrumbs}
            forceStackItems={forceStackItems}
            title={title}
            subTitle={subTitle}
          />
        </div>

        <div className={styles.breadcrumbsChildrenWrapper}>
          {breadcrumbsChildren}
        </div>
      </div>
      {tabs ? <div className={styles.tabsWrapper}>{tabs}</div> : null}
      {children}
    </Paper>
  );
};
